import { writable } from 'svelte/store';
function createNotifications() {
    const { subscribe, set, update } = writable([]);
    function add(notification) {
        const id = Date.now().toString();
        const fullNotification = Object.assign(Object.assign({}, notification), { id, duration: notification.duration || 5000 });
        update(notifications => [...notifications, fullNotification]);
        if (fullNotification.duration && fullNotification.duration > 0) {
            setTimeout(() => {
                remove(id);
            }, fullNotification.duration);
        }
        return id;
    }
    function remove(id) {
        update(notifications => notifications.filter(n => n.id !== id));
    }
    function clear() {
        set([]);
    }
    return {
        subscribe,
        add,
        remove,
        clear,
        success: (message, duration) => add({ message, type: 'success', duration }),
        error: (message, duration) => add({ message, type: 'error', duration }),
        info: (message, duration) => add({ message, type: 'info', duration }),
        warning: (message, duration) => add({ message, type: 'warning', duration })
    };
}
export const notifications = createNotifications();
